import React from 'react';

const Loader = () => {
    return (
        <div className="loaderFlex">
            <div className="loader" alt =" loader">
            </div>
        </div>
    )
}

export default Loader